import React from 'react';
import { ParticipantStep } from '../../../../../../types/v3Types';
import { ButtonNames } from '../../../../../../contexts/main/biInterfaces';
import { classes } from '../SidebarLayoutForParticipant.st.css';
import { StartButton } from './StartButton';
import { Props } from '../interfaces';

export interface SidebarStartButtonProps {
  props: Props;
  isProgramFinished: boolean;
  getIsStartDisabled: () => boolean;
  setStep: (currentStep: ParticipantStep, preventScrolling?: boolean) => void;
  sendBiButtonClick: (buttonName: ButtonNames, step?: string) => void;
  scrollToContent: () => void;
}

export const SidebarStartButton: React.FC<SidebarStartButtonProps> = ({
  props,
  isProgramFinished,
  getIsStartDisabled,
  setStep,
  sendBiButtonClick,
  scrollToContent,
}) => {
  if (!props.isMobile || isProgramFinished) {
    return null;
  }

  return (
    <div className={classes.startButton}>
      <StartButton
        props={props}
        getIsStartDisabled={getIsStartDisabled}
        setStep={setStep}
        sendBiButtonClick={sendBiButtonClick}
        scrollToContent={scrollToContent}
      />
    </div>
  );
};
